var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('preview-section'),_c('solve-section'),_c('find-section'),_c('why-section'),_c('selection-section'),_c('comfortable-section'),_c('faq-section'),_c('request-section')],1)}
var staticRenderFns = []

export { render, staticRenderFns }